"use client";

import { useEffect } from "react";

const HYDRATED_ATTRIBUTE = "data-seoh-react-hydrated";
const HYDRATED_EVENT = "seoh:react-hydrated";

export default function MarketingHydrationSignal() {
  useEffect(() => {
    document.documentElement.setAttribute(HYDRATED_ATTRIBUTE, "true");
    window.dispatchEvent(new Event(HYDRATED_EVENT));
  }, []);

  return null;
}
